<span class="badge-container">
  <span class="icon-corner-down-right-2 color-primary"></span>
  <span *ngIf="_showOnBehalfOf" class="whitespace-nowrap">
    <strong class="color-primary">
      {{ "label.ON_BEHALF_USER" | translate }}
    </strong>
  </span>
  <span
    class="flex items-center justify-start delegator-name overflow-hidden"
  >
    <img
      [src]="avatar ? avatar : '/assets/images/avatar.jpg'"
      class="b-circle"
      alt="main user info"
      width="16"
      height="16"
    />
    <span class="delegatee-name overflow-hidden text-ellipsis">
      {{ delegatee }}
    </span>
  </span>
</span>
